<div class="modal" *ngIf="open">
  <form class="container" [formGroup]="formCalendar" id="form">
   
    <div class="header-title">
      <input type="text" placeholder="Adicionar título" formControlName="title" id="title" name="title" maxlength="120">
      <button class="btn clear" type="button" id="btn-event-cancel" (click)="closeModal()">
        <img src="../../../assets/svgs/close_btn.svg" alt="Fechar">
      </button>
    </div>

    <div class="type-menu">
      <app-button-list [listActions]="listActions" [indexId]="id_type" (sendAction)="actionButtons($event)"></app-button-list>
    </div>

    <div class="actions">

      <!-- EVENTS -->
      <!-- DESK - OK -->
      <!-- MOBILE - OK -->
      <div class="events" *ngIf="id_type === 0">
        <div class="date-events">
          <div class="input-events">
            <label for="data-events-time">Data</label>
            <lib-datepicker 
              id="data-events-time" class="date-full-line" format='dd/MM/yyyy' 
              [date]="formCalendar.get('date').value" 
              (dateChange)="formCalendar.get('date').setValue($event)"
              [allowPastDate]="true" [allowFutureDate]="true"></lib-datepicker>
          </div>
          <div class="input-events">
            <label for="date-events-hours">Hora</label>
            <app-timepicker formControlName="hour" (selectValue)="formCalendar.get('hour').setValue($event)"
              isWidth="true" id="date-task-hours" placeholder="Definir"></app-timepicker>
          </div>
          <app-select 
            class="select-item"
            id="event-action-select"
            placeholder="Selecione"
            [textTitle]="''"
            height="150"
            labelText=""
            [showSearch]="false"
            field=""
            sizeList="0"
            [listItems]="eventsActions"></app-select>
        </div>
        <div class="notification-events">
          <div class="diviser">
            <app-input
              class="bell-events"
              [iconPathAlt]="{
                alt: 'Data',
                path: 'bell'
              }"
              id="data-bell"
              label="Notificação"
              (input)="removeCaracter($event)"
              formControlName="notification_time"
              [maxlength]="3"
              placeholder=""></app-input>
            <app-select 
              class="select-item"
              id="event-time-select"
              placeholder="Selecione"
              [textTitle]="''"
              height="150"
              labelText=""
              [showSearch]="false"
              field=""
              sizeList="0"
              [listItems]="timeList"></app-select>
          </div>
         
          <app-input
            class="input-full-events"
            id="location"
            label="Local"
            [maxlength]="180"
            placeholder="Endereço, salas de reuniões, links etc."></app-input>
        </div>
        <div class="input-tag-events">
          <app-input-tag
            id="event-input-tag"
            TG_icon="user"
            TG_label="Convidar participantes"
            [TG_Regex]="emailRegex"
            [TG_list]="formCalendar.get('invaits').value"
            (sendTags)="formCalendar.get('invaits').setValue($event)"></app-input-tag>
        </div>
        <div class="text-field">
          <label for="text-id-event">Descrição ou comentário</label>
          <textarea class="input-area" name="text-id-event" id="text-events"  maxlength="800"></textarea>
        </div>
      </div>

      <!-- TASK -->
      <!-- DESK - OK -->
      <!-- MOBILE - OK -->
      <div class="task" *ngIf="id_type === 1">

        <div class="date-task">
          <div class="input-task">
            <label for="data-task-time">Data</label>
            <lib-datepicker 
            id="data-task-time" class="date-full-line" 
            [date]="formCalendar.get('date').value" 
            (dateChange)="formCalendar.get('date').setValue($event)"
            format='dd/MM/yyyy' [allowPastDate]="true" [allowFutureDate]="true"></lib-datepicker>
          </div>

          <div class="input-task">
            <label for="date-task-hours">Hora</label>
            <app-timepicker isWidth="true" formControlName="hour" (selectValue)="formCalendar.get('hour').setValue($event)" id="date-task-hours" placeholder="Definir"></app-timepicker>
          </div>
          <app-select 
            class="select-item"
            id="task-select-item"
            placeholder="Selecione"
            [textTitle]="''"
            height="150"
            labelText=""
            [showSearch]="false"
            field=""
            sizeList="0"
            [listItems]="eventsActions"></app-select>
         </div>
  
         <div class="notification-task">
          <app-input
            class="bell-task"
            [iconPathAlt]="{
              alt: 'Data',
              path: 'bell'
            }"
            id="data-task-bell"
            label="Notificação"
            (input)="removeCaracter($event)"
            formControlName="notification_time"
            [maxlength]="3"
            placeholder=""></app-input>
          <app-select 
            class="select-item"
            id="task-select-time"
            placeholder="Selecione"
            [textTitle]="''"
            height="150"
            labelText=""
            [showSearch]="false"
            field=""
            sizeList="0"
            [listItems]="timeList"></app-select>
        </div>
  
        <div class="input-tag-task">
          <app-input-tag
            TG_icon="user"
            id="task-input-tag"
            TG_label="Convidar participantes"
            [TG_Regex]="emailRegex"
            [TG_list]="formCalendar.get('invaits').value"
            (sendTags)="formCalendar.get('invaits').setValue($event)"></app-input-tag>
        </div>
  
        <div class="text-field">
          <label for="text-id-event">Descrição ou comentário</label>
          <textarea class="input-area" name="text-id-event" id="text-task"  maxlength="800"></textarea>
        </div>

      </div>

      <!-- REMINDER -->
      <!-- DESK - OK -->
      <!-- MOBILE - OK -->
      <div class="reminder" *ngIf="id_type === 2">
        <div class="date-reminder">
          <div class="diviser">
            <div class="input-reminder">
              <label for="data-reminder-time">Data</label>
              <lib-datepicker 
                id="data-reminder-time" class="date-full-line" 
                [date]="formCalendar.get('date').value" 
                (dateChange)="formCalendar.get('date').setValue($event)"
                format='dd/MM/yyyy' [allowPastDate]="true" [allowFutureDate]="true"></lib-datepicker>
            </div>
            <div class="input-reminder">
              <label for="date-reminder-hours">Hora</label>
              <app-timepicker isWidth="true" formControlName="hour" (selectValue)="formCalendar.get('hour').setValue($event)"  id="date-task-hours" placeholder="Definir"></app-timepicker>
            </div>
          </div>
         
          <app-select 
            class="select-item"
            id="reminder-select-item"
            placeholder="Selecione"
            [textTitle]="''"
            height="150"
            labelText=""
            [showSearch]="false"
            field=""
            sizeList="0"
            [listItems]="eventsActions"></app-select>
         </div>
  
         <div class="text-field">
          <label for="text-id-event">Descrição ou comentário</label>
          <textarea class="input-area" name="text-id-event" id="text-reminder"  maxlength="800"></textarea>
        </div>

      </div>

      <!-- RETURN -->
      <!-- DESK - OK -->
      <!-- MOBILE - OK -->
      <div class="return" *ngIf="id_type === 3">
        <app-input
          id="fac_vinc-return"
          label="Vincular à fac"
          placeholder="Nome ou número da fac"></app-input>
        <div class="stage-return">
          <app-select
            class="select-return"
            id="select-return-item"
            placeholder="Selecione"
            [textTitle]="''"
            labelText="Estágio do atendimento"
            height="240"
            [showSearch]="false"
            field=""
            sizeList="0"
            [listItems]="listStage"
            (sendSearch)="sendSearch($event)"
            ></app-select>
          <app-select
            class="type-contact"
            id="select-return-contact"
            placeholder="Contatos"
            [textTitle]="''"
            labelText="Tipo de contato"
            height="150"
            [showSearch]="false"
            field=""
            sizeList="0"
            [listItems]="contactList"></app-select>
          <div class="diviser">
            <div class="input-return">
              <label for="data-visti-time">Data</label>
              <lib-datepicker 
                id="data-visti-time" 
                [date]="formCalendar.get('date').value" 
                (dateChange)="formCalendar.get('date').setValue($event)"
                format='dd/MM/yyyy' [allowPastDate]="true" [allowFutureDate]="true"></lib-datepicker>
            </div>
            <div class="input-date-return">
              <label for="date-hours">Hora</label>
              <app-timepicker isWidth="true" formControlName="hour" (selectValue)="formCalendar.get('hour').setValue($event)"  id="date-hours" placeholder="Definir"></app-timepicker>
            </div>
          </div>
          
        </div>

        <div class="notification-return">
          <div class="diviser">
            <app-input
              class="bell-return"
              [iconPathAlt]="{
                alt: 'Data',
                path: 'bell'
              }"
              id="data-return-bell"
              label="Notificação"
              (input)="removeCaracter($event)"
              formControlName="notification_time"
              [maxlength]="3"
              placeholder=""></app-input>
            <app-select 
              class="select-item"
              id="select-return-time"
              placeholder="Selecione"
              [textTitle]="''"
              height="150"
              labelText=""
              [showSearch]="false"
              field=""
              sizeList="0"
              [listItems]="timeList"></app-select>
          </div>
        </div>

        <div class="tag-return">
          <app-input-tag
            id="return-tag"
            TG_icon="user"
            TG_label="Convidar participantes"
            tabindex="0"
            [TG_Regex]="emailRegex"
            [TG_list]="formCalendar.get('invaits').value"
            (sendTags)="formCalendar.get('invaits').setValue($event)"></app-input-tag>
        </div>
          
        <div class="text-field">
          <label for="text-id-event">Descrição ou comentário</label>
          <textarea class="input-area" name="text-id-event" id="text-return"  maxlength="800"></textarea>
        </div>

      </div>

      <!-- VISIT -->
      <!-- DESK - OK -->
      <!-- MOBILE - OK -->
      <div class="visit" *ngIf="id_type === 4">
        <app-input
          id="fac_vinc-visit"
          label="Vincular à fac"
          placeholder="Nome ou número da fac"></app-input>

        <div class="stage-visit">
          <app-select
            class="select-visit"
            id="visit-select-item"
            placeholder="Selecione"
            [textTitle]="textSearching"
            labelText="Estágio do atendimento"
            height="250"
            [showSearch]="false"
            field=""
            sizeList="0"
            [listItems]="listStage"
            (sendSearch)="sendSearch($event)"
          ></app-select>
        
          <div class="diviser">
            <div class="input-visit">
              <label for="data-visti-time">Data</label>
              <lib-datepicker id="data-visti-time" 
                [date]="formCalendar.get('date').value" 
                (dateChange)="formCalendar.get('date').setValue($event)"
                format='dd/MM/yyyy' [allowPastDate]="true" [allowFutureDate]="true"></lib-datepicker>
            </div>
            <div class="input-date-visit">
              <label for="date-hours">Hora</label>
              <app-timepicker isWidth="true" formControlName="hour" (selectValue)="formCalendar.get('hour').setValue($event)"  id="date-hours" placeholder="Definir"></app-timepicker>
            </div>
          </div>
          
        </div>

        <div class="notification-visit">
          <div class="diviser">
            <app-input
              class="bell-visit"
              [iconPathAlt]="{
                alt: 'Data',
                path: 'bell'
              }"
              id="data-visit-bell"
              label="Notificação"
              (input)="removeCaracter($event)"
              [maxlength]="3"
              placeholder=""
              formControlName="notification_time"></app-input>

            <app-select 
              class="select-item"
              id="visit-select-item-time"
              placeholder="Selecione"
              [textTitle]="''"
              height="150"
              labelText=""
              [showSearch]="false"
              field=""
              sizeList="0"
              [listItems]="timeList"></app-select>
          </div>
          <app-input
            class="location-visit"
            id="location-visit"
            label="Local"
            [maxlength]="180"
            placeholder="Endereço, salas de reuniões, links etc."
            formControlName="location"></app-input>
        </div>

        <div class="tag-visit">
          <app-input-tag
            id="visit-input-tag"
            TG_icon="user"
            TG_label="Convidar participantes"
            [TG_Regex]="emailRegex"
            [TG_list]="formCalendar.get('invaits').value"
            (sendTags)="formCalendar.get('invaits').setValue($event)"></app-input-tag>
        </div>
          
        <div class="text-field">
          <label for="text-id-event">Descrição ou comentário</label>
          <textarea class="input-area" name="text-id-event" id="text-visit" maxlength="800" formControlName="description"></textarea>
        </div>
      </div>
    </div>

    <div class="action-buttons">
      <button type="button" class="btn-cancel" id="btn-cancel-form" (click)="closeModal()">Cancelar</button>
      <lib-button-primary id="btn-submited" [icon]="''" [maxWidth]="''" >Salvar</lib-button-primary>
    </div>

  </form>
</div>